var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.53 27.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Skupine") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ikone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ikone-2",
    "data-name": "ikone"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 10.5,
    height: 10.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.03,
    y: 1,
    width: 10.5,
    height: 10.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 16.2,
    width: 10.5,
    height: 10.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.03,
    y: 16.2,
    width: 10.5,
    height: 10.61
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/groupIcon.252c95bfb669561198a890a977df9b66.svg";
export { ForwardRef as ReactComponent };